import { shallowEqual, useSelector } from 'react-redux';
import { getCaseHistory } from '../ducks';

export const useGetCaseHistory = () => {
  const { data, isLoading } = useSelector(getCaseHistory, shallowEqual);
  return { data, isLoading };
};
